define(function (require, exports, module) {
    return {
        PREGAME_UPDATE: 'pregame_update',
        VIEW_READY: 'game_view_ready',
        PLAYS: 'play_update',
        PLAYERS: 'players_update',
        GAME: 'game_update',
        BOXSCORE: 'boxscore_update',
        BENCH: 'bench_update',
        LINESCORE: 'linescore_update',
        GAMECENTER: 'gamecenter_update',
        SCORES: 'scores_update',
        HITCHART: 'hitchart_update',
        MINISCOREBOARD: 'miniscoreboard_update',
        SCORING_PLAYS: 'scores_update',
        INNING: 'inning_update',
        ALL_INNINGS: 'all_innings_update',
        PLAYER_CARD: 'playercard_update',
        HOT_COLD_ZONE: 'hotcoldzone_update',
        DISPLAY_CONFIG: 'displayconfig_update',
        JINGLES: 'jingles_update',
        TEMPLATES: 'tpl_lib_update',
        VIDEO: 'video_update',
        LIVE_LOOKIN: 'liveLookin_update',
        GD_CONFIG: 'gdConfig_update',
        SKIN_CONFIG: 'skin_config_update',
        TIMECODE: 'timecode_update',
        STATIC_RESOURCES: 'staticresources_update',
        MOUNDBALL: 'moundball_update',
        BEGIN_COMMERCIAL_BREAK: 'beginCommercialBreak',
        END_COMMERCIAL_BREAK: 'endCommercialBreak',
        COMMERCIAL_COMPANION_RECEIVED: 'commercialCompanionReceived',
        GUMBO: 'gumbo_updated'
    };
});
